import Page from "../page";

function DataDeletion() {
  return (
    <Page>
      <h1>Suppression des données personnelles</h1>

      <h2>Votre droit à la suppression</h2>
      <p>
        Conformément aux réglementations en vigueur sur la protection des données personnelles, vous
        avez le droit de demander la suppression de toutes les données personnelles que nous
        détenons à votre sujet.
      </p>

      <h2>Quelles données sont concernées ?</h2>
      <p>Une demande de suppression inclut l'effacement de :</p>
      <ul>
        <li>Votre compte utilisateur et informations de profil</li>
        <li>Votre adresse e-mail et numéro de téléphone</li>
        <li>Vos adresses de livraison</li>
        <li>Vos photos téléchargées</li>
        <li>L'historique de vos commandes</li>
        <li>Toute autre donnée personnelle associée à votre compte</li>
      </ul>

      <h2>Comment demander la suppression ?</h2>
      <p>
        Pour demander la suppression de vos données personnelles, veuillez nous contacter par e-mail
        à l'adresse suivante :
      </p>
      <p>
        <strong>
          <a href="mailto:contact@lymaprint.com">contact@lymaprint.com</a>
        </strong>
      </p>
      <p>Dans votre e-mail, veuillez inclure :</p>
      <ul>
        <li>L'adresse e-mail associée à votre compte Lymaprint</li>
        <li>Une demande explicite de suppression de vos données</li>
      </ul>

      <h2>Délai de traitement</h2>
      <p>
        Votre demande sera traitée dans un délai maximum de 30 jours. Vous recevrez une confirmation
        par e-mail une fois la suppression effectuée.
      </p>

      <h2>Conséquences de la suppression</h2>
      <p>
        Veuillez noter que la suppression de vos données est irréversible. Une fois vos données
        supprimées :
      </p>
      <ul>
        <li>Vous ne pourrez plus accéder à votre compte</li>
        <li>Vos photos et créations seront définitivement effacées</li>
        <li>L'historique de vos commandes ne sera plus accessible</li>
      </ul>
      <p>
        Les données nécessaires au respect de nos obligations légales (notamment les factures)
        pourront être conservées pendant la durée requise par la loi.
      </p>
    </Page>
  );
}

export default DataDeletion;
